import React from "react"
import cn from "classnames"
import InputMask from "react-input-mask"
import Field, { describedBy } from "./Field"
import styles from "../../styles/scss/components/form/formSystem.module.scss"

// Same masks (and maskChar) as the legacy Input component, so masked values
// reach the Lambdas in exactly the format they do today, e.g. "(619) 555-0123".
const MASKS = {
    phone: "(999) 999-9999",
    date: "99/99/9999",
    upc: "9-99999-99999-9",
}

const TextInput = ({
    name,
    id = name,
    label,
    type = "text",
    required,
    help,
    error,
    mask,
    className,
    inputClassName,
    value,
    onChange,
    onBlur,
    ...rest
}) => {
    const inputProps = {
        id,
        name,
        type,
        value: value === null || value === undefined ? "" : value,
        onChange,
        onBlur,
        required,
        "aria-required": required || undefined,
        "aria-invalid": error ? "true" : undefined,
        "aria-describedby": describedBy(id, { help, error }),
        className: cn(styles.input, inputClassName),
        ...rest,
    }
    return (
        <Field
            id={id}
            label={label}
            required={required}
            help={help}
            error={error}
            className={className}
        >
            {mask ? (
                <InputMask {...inputProps} mask={MASKS[mask] || mask} maskChar=" " />
            ) : (
                <input {...inputProps} />
            )}
        </Field>
    )
}

export default TextInput
